import * as assets from '../../assets';
import { Box, Tooltip, tooltipClasses, useTheme } from '@mui/material';
import ImageButton from '../../components/sharedComponents/ImageButton';
import { useAppDispatch, useAppSelector } from '../../reduxStore/redux-hooks';
// import { setFiles, toggleModal } from '../../reduxStore/slices/FileUploadSlice';
import DatasetModal from '../../components/rightPanel/subpanel/dataset/createDataset/DatasetModal';
// import { findEmptyFileName } from 'components/staticComponents/staticUtiles';
// import { enqueueSnackbar } from 'notistack';
// import { useTranslation } from 'react-i18next';
import { setOpenCloseDatasetModal } from '../../reduxStore/slices/DataSetSlice';

interface fileUploadProps {
  disabled: boolean;
}

const FileUpload = ({ disabled }: fileUploadProps) => {
  const dispatch = useAppDispatch();
  // const { t } = useTranslation();
  const { fileUpload } = useAppSelector((state) => state.fileUpload);
  const theme = useTheme();

  const { openCloseDatasetModal } = useAppSelector((state) => state.dataset);
  // const fileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const files = e.target.files;
  //   if (!files && files!.length === 0) return;
  //   if (findEmptyFileName(files!)) {
  //     enqueueSnackbar(t('fileUpload.fileIsEmpty', { fileName: findEmptyFileName(files!) }), {
  //       variant: 'error',
  //     });
  //     return;
  //   }
  //   dispatch(setFiles(Array.from(files as FileList)));
  //   dispatch(toggleModal());
  //   e.target.value = '';
  // };
  const openModal = () => {
    dispatch(setOpenCloseDatasetModal(true));
  };
  const closeModal = () => {
    dispatch(setOpenCloseDatasetModal(false));
  };
  const queryInputActionsTooltipStyles = {
    sx: {
      [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#000000BA',
      },
      [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.arrow}`]: {
        '&::before': {
          backgroundColor: '#000000BA',
        },
      },
    },
  };
  return (
    <>
      <Box
        component="div"
        sx={{
          [theme.breakpoints.down('sm')]: {
            position: 'static',
          },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: fileUpload.uploadedFiles.length > 0 ? '-13px' : '11px',
          }}
        >
          <Tooltip
            title="Upload file"
            arrow
            placement="top"
            slotProps={{
              popper: queryInputActionsTooltipStyles,
            }}
          >
            <label
              htmlFor="file-upload"
              className="custom-file-upload"
              style={{ position: 'absolute', left: '0px' }}
              onClick={openModal}
            >
              <ImageButton disabled={disabled} srcFile={assets.attachFile} ariaLabel="File Upload" />
            </label>
          </Tooltip>
        </Box>
      </Box>
      {openCloseDatasetModal && <DatasetModal open={openCloseDatasetModal} onClose={closeModal} />}
    </>
  );
};

export default FileUpload;
